// extracted by mini-css-extract-plugin
module.exports = {"hr":"PostCommentCondition_hr__2VV8c"};